module.exports = __webpack_public_path__ + "img/logo-PNUD.38ed36cc.png";